var cssImage = {"imageBase":"Image-module_imageBase__bxvjq"};

export { cssImage as default };
